import {boot} from 'quasar/wrappers'
import Loading from 'quasar/src/plugins/Loading'
import { canRead, isAdmin } from 'src/pages/utils'
import {canSystemAdmin} from 'src/pages/authUtils.js'

const extractNodeId = (path) => {
  const match = path.match(/^\/node\/(\d+)/)
  return match ? Number(match[1]) : null
}

export default boot(({app, router, store}) => {
  const whiteList = ['auth-login', 'auth-mfa','auth-forget', 'auth-reissue','auth-reset','auth-email-auth']
  const navigationCandidates = new WeakMap()
  router.beforeEach(async (to, from, next) => {
    if (whiteList.includes(to.name)) {
      // ホワイトリストの場合はスルー
      next()
      return
    }
    const accessToken = localStorage.getItem('auth/ACCESS_TOKEN')
    // const accessToken = store.getters['auth/accessToken']
    if (accessToken) {
      // ログイン済
      Loading.show()
      await store.dispatch('common/setApiClients').catch(() => console.error('APIクライアントの生成に失敗しました。'))
      const hasFullRouteData = store.getters['common/routeInitScope'] === 'full' && store.state.common.nodes.length > 0
      if (!store.getters['common/isCommonLoaded']) {
        try {
          await store.dispatch('common/loadCommonData')
        } catch (e) {
          console.error(`共通データ情報取得に失敗しました。${e}`)
          Loading.hide()
          next({name: 'auth-login'})
          return
        }
      }

      if (to.path.startsWith('/node')) {
        const routeNodeId = extractNodeId(to.path)
        const currentNode = store.getters['common/currentNode']
        const needsCurrentNode = !currentNode || currentNode.id !== routeNodeId

        if (!store.getters['common/isRouteLoaded'] || (!hasFullRouteData && needsCurrentNode)) {
          try {
            await store.dispatch('common/loadRouteData', {
              scope: 'full',
              loadNodes: true,
              light: true,
              nodeId: null
            })
          } catch (e) {
            console.error(`階層データ情報取得に失敗しました。${e}`)
            Loading.hide()
            next({name: 'auth-login'})
            return
          }
        }

        if(store.state.common.nodes.length == 0 && !store.getters['common/currentNode']) {
          Loading.hide()
          next({name: 'error-401'})
          return
        }

        if(to.params.nodeId === "undefined" || to.params.nodeId === "null") {
          const node = store.getters['common/node'](to.params.nodeId)
          to.params.nodeId = node.id
          Loading.hide()
          next({name: to.name, params: to.params})
          return
        }

        try {
          const candidate = await store.dispatch('common/prepareNodeNavigation', routeNodeId)
          if (!candidate) {
            Loading.hide()
            next(false)
            return
          }
          navigationCandidates.set(to, candidate)
        } catch (e) {
          console.error(`階層navigation context取得に失敗しました。${e}`)
          Loading.hide()
          next(false)
          return
        }
      } else if (!store.getters['common/isRouteLoaded']) {
        try {
          await store.dispatch('common/loadRouteData', {scope: 'full', loadNodes: true, light: true})
        } catch (e) {
          console.error(`共通データ情報取得に失敗しました。${e}`)
          Loading.hide()
          next({name: 'auth-login'})
          return
        }
      }

      if(to.path.startsWith('/admin')) {
        if (canSystemAdmin(store.state.common.userInfo,store.state.common.userInfo.organization) && !hasFullRouteData) {
          await store.dispatch('common/loadRouteData', {scope: 'full', loadNodes: true}).catch((e) => {
            console.error(`管理画面用の階層データ取得に失敗しました。${e}`)
            next({name: 'auth-login'})
          })
        }
        Loading.hide()
        if(canSystemAdmin(store.state.common.userInfo,store.state.common.userInfo.organization)) {
          next()
        } else {
          next({name: 'error-401'})
        }
        return
      }

      if(to.path.startsWith('/node')) {
        Loading.hide()
        next()
        return
      }

      Loading.hide()
      next()

    } else {
      // 未ログイン
      const routeObj = {
        name: 'auth-login',
        query: {}
      }

      // routesに記載してるかどうか
      if (to.name !== undefined) {
        routeObj.query.redirect = to.path
      }
      next(routeObj)
    }
  })

  router.afterEach((to, from, failure) => {
    const candidate = navigationCandidates.get(to)
    navigationCandidates.delete(to)
    if (!candidate || failure) {
      return
    }
    return store.dispatch('common/commitNodeNavigation', {
      candidate,
      routeNodeId: extractNodeId(to.path)
    })
  })
})
